import React from "react";
import { object } from "prop-types";
import get from "lodash/get";

import Organism1 from "../ThreeCollection9Stories/Organism1/index";

import "./threeCollection9Stories.m.css";

const ThreeCollection9Stories = ({ collection }) => {
  const collectionToLoad = get(collection, ["associated-metadata", "number_of_collections_to_show"], 3);
  const collectionItems = collection.items.filter((item) => item.type === "collection").slice(0, collectionToLoad);
  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showLoadMoreButton = get(collection, ["associated-metadata", "hide_load_more_button"], null);
  const storiesToLoad = get(collection, ["associated-metadata", "number_of_stories_inside_collection_to_show"], 4);
  return collectionItems.length > 0 ? (
    <div styleName="base" className="three-collection-9-stories">
      {collectionItems.map((item, index) => (
        <Organism1
          key={index}
          collection={item}
          showCollectionName={showCollectionName}
          showLoadMoreButton={showLoadMoreButton}
          src="three-collection-9-stories"
          updatedFont={true}
          storiesToLoad={storiesToLoad}
          widths={[320]}
        />
      ))}
    </div>
  ) : null;
};

ThreeCollection9Stories.nestedCollectionLimit = [3, 3, 3];

ThreeCollection9Stories.propTypes = {
  collection: object,
};

export default ThreeCollection9Stories;
